// extracted by mini-css-extract-plugin
module.exports = {"root":"Subject_root__1y7pZ","selected":"Subject_selected__3H-7E"};